import { motion } from 'framer-motion';
import { useDemoTheme } from './DemoThemeContext';

const LABELS = { a: 'A', b: 'B', c: 'C', d: 'D' };

export default function MCQQuestion({ question, selectedAnswer, onAnswer }) {
  const { isDark } = useDemoTheme();

  return (
    <div className="space-y-3" data-testid={`mcq-question-${question.id}`}>
      {question.options.map((option) => {
        const isSelected = selectedAnswer === option.id;
        return (
          <motion.button
            key={option.id}
            data-testid={`mcq-option-${question.id}-${option.id}`}
            onClick={() => onAnswer(question.id, option.id)}
            whileHover={{ x: 2 }} whileTap={{ scale: 0.99 }} transition={{ duration: 0.15 }}
            className="w-full text-left rounded-xl px-5 py-4 flex items-center gap-4 transition-all duration-200"
            style={{
              background: isSelected ? 'rgba(124,58,237,0.1)' : 'var(--d-subtle)',
              border: isSelected ? '1px solid rgba(124,58,237,0.5)' : '1px solid var(--d-border-sub)',
            }}
            onMouseEnter={(e) => { if (!isSelected) { e.currentTarget.style.background = 'var(--d-hover)'; e.currentTarget.style.border = '1px solid var(--d-border)'; } }}
            onMouseLeave={(e) => { if (!isSelected) { e.currentTarget.style.background = 'var(--d-subtle)'; e.currentTarget.style.border = '1px solid var(--d-border-sub)'; } }}
          >
            {/* Label */}
            <div className="flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold font-mono transition-all duration-200"
              style={{
                background: isSelected ? 'rgba(124,58,237,0.6)' : 'var(--d-hover)',
                color: isSelected ? '#fff' : 'var(--d-text-3)',
                border: isSelected ? '1px solid rgba(124,58,237,0.8)' : '1px solid var(--d-border)',
              }}>
              {LABELS[option.id]}
            </div>
            {/* Text */}
            <span className="text-sm leading-relaxed font-mono flex-1 transition-colors duration-200"
              style={{ color: isSelected ? 'var(--d-text-hi)' : 'var(--d-text-2)' }}>
              {option.text}
            </span>
            {/* Check */}
            {isSelected && (
              <motion.div initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
                className="ml-auto flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs text-white"
                style={{ background: 'rgba(124,58,237,0.7)' }}>✓</motion.div>
            )}
          </motion.button>
        );
      })}
    </div>
  );
}
